<template>
    <div>
        <beautiful-chat
                :participants="participants"
                :titleImageUrl="titleImageUrl"
                :onMessageWasSent="onMessageWasSent"
                :messageList="messageList"
                :newMessagesCount="newMessagesCount"
                :isOpen="isChatOpen"
                title="К списку пользователей"
                :sendUserName="this.sendUser.name"
                :sendUserFullName="this.sendUser.fullname"
                :close="closeChat"
                :open="openChat"
                :showEmoji="false"
                placeholder="Написать сообщение"
                :showFile="false"
                :showTypingIndicator="showTypingIndicator"
                :colors="colors"
                :alwaysScrollToBottom="alwaysScrollToBottom"
                :messageStyling="messageStyling" />
    </div>
</template>

<script>
    import axios from 'axios'
    import SockJS from "sockjs-client";
    import Stomp from "webstomp-client";
    export default {

        data() {
            return {
                addMessage: true,
                backUrl: null,
                rowsPerPage: 20,
                scrollBlock: 1,
                sendUser: '',
                role: '',
                user_id: '',
                token: '',
                connected: false,
                stompClient: null,
                socket: null,
                participants: [], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
                titleImageUrl: 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png',
                messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
                newMessagesCount: null,
                isChatOpen: false, // to determine whether the chat window should be open or closed
                showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
                colors: {
                    header: {
                        bg: '#4e8cff',
                        text: '#ffffff'
                    },
                    launcher: {
                        bg: '#4e8cff'
                    },
                    messageList: {
                        bg: '#ffffff'
                    },
                    sentMessage: {
                        bg: '#4e8cff',
                        text: '#ffffff'
                    },
                    receivedMessage: {
                        bg: '#eaeaea',
                        text: '#222222'
                    },
                    userInput: {
                        bg: '#f4f7f9',
                        text: '#565867'
                    }
                }, // specifies the color scheme for the component
                alwaysScrollToBottom: true, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
                messageStyling: true // enables *bold* /emph/ _underline_ and such (more
            }
        },

        created(){
            this.token = localStorage.getItem('token');
            this.auth_user = localStorage.getItem('auth_user');
            this.role = localStorage.getItem('role');
            this.backUrl = localStorage.getItem('url');
            this.user_id = localStorage.getItem('user_id');

            Event.$on('sendUser',(item) => {
                this.alwaysScrollToBottom = true
                this.sendUser = item;
                this.getMessages(item.id)
                for(let i  = 0; i < this.participants.length; i++){
                    if(this.participants[i].id == item.id){
                        if(this.participants[i].newMessNum != null){
                            this.newMessagesCount -= 1
                        }
                        this.participants[i].newMessNum = null
                    }
                }
            });

            Event.$on('clearMessage',() => {
                this.messageList = [];
                this.sendUser = ''
                this.scrollBlock = 1;
            });

            Event.$on('messagePaging',() => {
                this.alwaysScrollToBottom = false
                this.scrollBlock += 1;
                this.getMessagesPaging(this.sendUser.id)
            });

            this.connect()
            this.getUsers()

        },

        beforeDestroy () {
            Event.$off('sendUser');
            Event.$off('clearMessage');
            Event.$off('messagePaging');
        },

        methods: {

            connect() {
                let username = localStorage.getItem('auth_user');
                this.socket = new SockJS(this.backUrl + "/websocket-userhub");
                this.stompClient = Stomp.over(this.socket);
                this.stompClient.connect({username}, this.connectionSuccess, this.connectionFailure);
            },

            connectionSuccess(){
                this.connected = true;
                this.stompClient.subscribe('/api/socket/user/status', this.onUserConnected);
                this.stompClient.subscribe('/api/socket/message/receive/' + this.auth_user, this.onMessageReceived);
                this.stompClient.subscribe('/api/socket/message/confirmation/'+this.auth_user);
                this.stompClient.send('/api/socket/user/getAllOnlineUsers');
                this.stompClient.subscribe('/api/socket/user/statusAll/getAllOnline/'+this.auth_user, this.getOnlineAll);

            },

            onUserConnected(data){
                let userConn = JSON.parse(data.body)
                for ( let status in userConn ) {
                    if(status == 'CONNECTED'){
                        for(let i = 0; i < this.participants.length;i++){
                            if(userConn[status] == this.participants[i].name){
                                this.participants[i].active = true
                            }
                        }
                    }else{
                        for(let i = 0; i < this.participants.length;i++){
                            if(userConn[status] == this.participants[i].name){
                                this.participants[i].active = false
                            }
                        }
                    }

                }
            },

            onMessageReceived(data){
                this.alwaysScrollToBottom = true
                if(this.isChatOpen && this.sendUser.id == JSON.parse(data.body).createdBy) {
                    this.messageList.push({
                        type: 'text',
                        author: JSON.parse(data.body).createdBy,
                        data: {
                            text: JSON.parse(data.body).text,
                            createdAt: JSON.parse(data.body).createdAt
                        }
                    })
                }else{
                    for(let i  = 0; i < this.participants.length; i++){
                        if(this.participants[i].id == JSON.parse(data.body).createdBy){
                            if(this.participants[i].newMessNum == null){
                                this.newMessagesCount += 1
                            }
                            this.participants[i].newMessNum += 1
                        }
                    }
                }


            },

            getOnlineAll(data){
                let onlineUsers = JSON.parse(data.body);

                for(let i = 0; i < this.participants.length;i++){
                    for(let j = 0; j < onlineUsers.length;j++){
                       if(this.participants[i].name == onlineUsers[j]){
                           this.participants[i].active = true
                       }
                    }
                }
            },

            connectionFailure(){
                this.connected = false;
            },

            disconnect() {
                if (this.stompClient) {
                    this.stompClient.disconnect();
                }
                this.connected = false;
            },

            getUsers(){

                axios({
                    method: 'get',
                    url: this.backUrl + '/api/users',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    if(this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT') {
                        for (let i = 0; i < response.data.metadata.actual_count; i++) {
                            if((response.data.data[i].role == 'ROLE_ADMIN' || response.data.data[i].role == 'ROLE_EXPERT') && response.data.data[i].username != this.auth_user) {
                                this.participants.push({
                                    id: response.data.data[i].id,
                                    uuid: response.data.data[i].uuid,
                                    name: response.data.data[i].username,
                                    fullname: response.data.data[i].fullname,
                                    active: false,
                                    newMessNum: null,
                                })
                            }
                        }
                    }else{
                        for (let i = 0; i < response.data.metadata.actual_count; i++) {
                            if(response.data.data[i].username != this.auth_user) {
                                this.participants.push({
                                    id: response.data.data[i].id,
                                    uuid: response.data.data[i].uuid,
                                    name: response.data.data[i].username,
                                    fullname: response.data.data[i].fullname,
                                    active: false,
                                    newMessNum: null,
                                })
                            }

                        }
                    }
                })
            },

            getMessages(id){
                let startIndex = (this.scrollBlock - 1) * this.rowsPerPage
                axios({
                    method: 'get',
                    url: this.backUrl + `/api/chat/messages/history?start_index=${startIndex}&count=${this.rowsPerPage}&eq_opponent_id=${id}`,
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token,
                    },
                    data:{}
                }).then(response => {
                    for(let i = 0; i < response.data.data.length; i++){
                        if(response.data.data[i].createdBy == this.user_id){
                            this.messageList.push({
                                type: 'text',
                                author: 'me',
                                data: {
                                    text: response.data.data[i].text ,
                                    createdAt: response.data.data[i].createdAt
                                }
                            })
                        }else{
                            this.messageList.push({
                                type: 'text',
                                author: response.data.data[i].createdBy ,
                                data: {
                                    text: response.data.data[i].text,
                                    createdAt: response.data.data[i].createdAt
                                }
                            })
                        }

                    }
                    this.messageList = this.messageList.reverse()
                })
            },

            getMessagesPaging(id){
                let startIndex = (this.scrollBlock - 1) * this.rowsPerPage
                axios({
                    method: 'get',
                    url: this.backUrl + `/api/chat/messages/history?start_index=${startIndex}&count=${this.rowsPerPage}&eq_opponent_id=${id}`,
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token,
                    },
                    data:{}
                }).then(response => {
                    for(let i = 0; i < response.data.data.length; i++){
                        if(response.data.data[i].createdBy == this.user_id){
                            this.messageList.unshift({
                                type: 'text',
                                author: 'me',
                                data: {
                                    text: response.data.data[i].text ,
                                    createdAt: response.data.data[i].createdAt
                                }
                            })
                        }else{
                            this.messageList.unshift({
                                type: 'text',
                                author: response.data.data[i].createdBy ,
                                data: {
                                    text: response.data.data[i].text,
                                    createdAt: response.data.data[i].createdAt
                                }
                            })
                        }

                    }
                })
            },

            onMessageWasSent (message) {
                this.alwaysScrollToBottom = true
                let date = Date.now()
                message.data.createdAt = date
                const msg = {
                    "text": message.data.text,
                    "addressedTo": this.sendUser.id,
                    "uuid": this.sendUser.uuid
                };
                this.stompClient.send("/api/socket/message/send", JSON.stringify(msg), {});

                this.messageList = [ ...this.messageList, message ]

            },

            openChat () {
                // called when the user clicks on the fab button to open the chat
                this.isChatOpen = true
                if(this.sendUser) {
                    for (let i = 0; i < this.participants.length; i++) {
                        if (this.participants[i].id == this.sendUser.id) {
                            if (this.participants[i].newMessNum != null) {
                                this.newMessagesCount -= 1
                            }
                            this.participants[i].newMessNum = null
                        }
                    }
                }
            },

            closeChat () {
                this.isChatOpen = false
            },

        }
    }
</script>

<style>
    .sc-chat-window.opened{
        z-index: 999;
    }
</style>